"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
const validations_1 = require("../../utils/validations");
const StreamMessage_1 = __importDefault(require("./StreamMessage"));
const GroupKeyMessage_1 = __importDefault(require("./GroupKeyMessage"));
var ErrorCode;
(function (ErrorCode) {
    // TODO define the values, remove PLACEHOLDER
    ErrorCode["PLACEHOLDER"] = "PLACEHOLDER";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
class GroupKeyErrorResponse extends GroupKeyMessage_1.default {
    constructor({ requestId, streamId, errorCode, errorMessage, groupKeyIds }) {
        super(streamId, StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_ERROR_RESPONSE);
        validations_1.validateIsString('requestId', requestId);
        this.requestId = requestId;
        validations_1.validateIsString('errorCode', errorCode);
        this.errorCode = errorCode;
        validations_1.validateIsString('errorMessage', errorMessage);
        this.errorMessage = errorMessage;
        validations_1.validateIsArray('groupKeyIds', groupKeyIds);
        this.groupKeyIds = groupKeyIds;
    }
    toArray() {
        return [this.requestId, this.streamId, this.errorCode, this.errorMessage, this.groupKeyIds];
    }
    static fromArray(arr) {
        const [requestId, streamId, errorCode, errorMessage, groupKeyIds] = arr;
        return new GroupKeyErrorResponse({
            requestId,
            streamId,
            errorCode,
            errorMessage,
            groupKeyIds,
        });
    }
}
exports.default = GroupKeyErrorResponse;
GroupKeyMessage_1.default.classByMessageType[StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_ERROR_RESPONSE] = GroupKeyErrorResponse;
//# sourceMappingURL=GroupKeyErrorResponse.js.map